import { PeriodSchema, REPORT_JOB_TYPES } from '@weft/types';
import { oz } from '@weft/utils';

export const TriggerMonthlyClosureReportJobParametersSchema = oz.object({
  reportJobType: oz.literal(REPORT_JOB_TYPES.MonthlyClosure),
  reportName: oz.string().optional(),
  period: PeriodSchema,
});

export type TriggerMonthlyClosureReportJobParameters = oz.TypeOf<typeof TriggerMonthlyClosureReportJobParametersSchema>;